<template>
    <div
id="quotelModal" ref="quotelModal" class="modal fade" tabindex="-1" aria-labelledby="quotelModal"
        aria-hidden="true"
>
        <div 
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!px-3 laptop:!w-[500px] mobile:!mx-auto laptop:mx-[unset] mobile:!relative laptop:!absolute mobile:!right-[unset] laptop:!right-4 mobile:!top-[unset] laptop:!top-0 !m-0 h-full"
>
            <div class="modal-content select-none">
                <div class="modal-body !p-3 !pb-0 font-roboto flex flex-col">
                    <!-- Figma "Work Orders - Universal Quotes - Create Universal Quote - Step 1 / Step 2" (658-931, 658-1196) -->
                    <FxModalHeader title="Create Universal Quote" />

                    <!-- customer: phone + details + address in one step; kept mounted so Back from the quote step keeps the data -->
                    <div v-show="step === 'customer'" class="uqc flex-1 flex flex-col gap-[12px] px-[6px]">
                        <p class="m-0 text-center text-[14px] leading-[20px] text-[#333333]">
                            Please enter Consumer's phone number<br>to create an Universal Quote
                        </p>
                        <div>
                            <label for="uqcPhone" class="uqcLabel">Phone Number <span class="text-[#EE5851]">*</span></label>
                            <inputComponent id="uqcPhone" ref="phoneRef" v-model="phone" name="phone" required mask="(###) ###-####"
                                placeholder="Enter Number" error-message="Invalid phone number" :custom-class="fieldClass" />
                        </div>
                        <!-- one step (user, 20 Oct): an existing consumer's details fill in from the phone lookup (locked), a new one stays
                             empty and editable -->
                            <div>
                                <label for="uqcFirst" class="uqcLabel">First Name <span class="text-[#EE5851]">*</span></label>
                                <inputComponent id="uqcFirst" ref="firstNameRef" v-model="first_name" name="firstName" required
                                    placeholder="Enter First Name" :disabled="isConsumerFound" :custom-class="fieldClass" />
                            </div>
                            <div>
                                <label for="uqcLast" class="uqcLabel">Last Name <span class="text-[#EE5851]">*</span></label>
                                <inputComponent id="uqcLast" ref="lastNameRef" v-model="last_name" name="lastName" required
                                    placeholder="Enter Last Name" :disabled="isConsumerFound" :custom-class="fieldClass" />
                            </div>
                            <div>
                                <label for="uqcEmail" class="uqcLabel">Email</label>
                                <inputComponent id="uqcEmail" ref="emailRef" v-model="email" name="email"
                                    :regex="$constants.EMAIL_REGEX" error-message="Please enter a valid email address"
                                    placeholder="Enter Email" :disabled="isConsumerFound" :custom-class="fieldClass" />
                            </div>

                            <!-- Android "Source Type": an existing consumer with appointments / RQs / S&R jobs can start the quote from one of them -->
                            <div v-if="isConsumerFound && sourceTypeOptions.length > 1">
                                <label class="uqcLabel">Source Type <span class="text-[#EE5851]">*</span></label>
                                <FxSelect v-model="sourceType" :options="sourceTypeOptions" placeholder="Select Source Type" inline
                                    @change="sourceId = null" />
                            </div>
                            <div v-if="isConsumerFound && isSourceFlow">
                                <label class="uqcLabel">Select {{ sourceTypeLabel }} <span class="text-[#EE5851]">*</span></label>
                                <FxSelect v-model="sourceId" :options="sourceIdOptions" :placeholder="'Select ' + sourceTypeLabel" inline />
                            </div>

                            <!-- Address: the consumer's saved addresses, or add a new one -->
                            <div v-show="!isVisible && !isSourceFlow">
                                <label for="uqcAddress" class="uqcLabel">Address <span class="text-[#EE5851]">*</span></label>
                                <div>
                                    <!-- project dropdown (same look as checkout "Financial Institution") -->
                                    <customDropdown v-model="selectedAddressId" :items="addressOptions" button-text="Select Address"
                                        :button-warpper-class="'relative w-full'"
                                        :button-class="'!rounded-[8px] border border-[#E1E5EF] flex items-center justify-between gap-[8px] px-[12px] !h-[40px] w-full bg-white text-left'"
                                        :button-text-class="['font-roboto text-[14px] truncate', selectedAddress ? 'text-[#333333]' : 'text-[#AAAAAA]']"
                                        :button-icon-class="'hidden'"
                                        :dropdown-list-class="'relative mt-[6px] w-full rounded-[8px] border border-[#E1E5EF] z-20 bg-white shadow-[0px_4px_12px_0px_#0000001A] overflow-hidden'"
                                        :dropdown-list-l-i-class="'hover:bg-[#F3F4F7]'"
                                        :dropdown-list-anchor-class="'no-underline font-roboto block px-[12px] py-[10px] text-[13px] cursor-pointer text-[#333333] hover:bg-[#F3F4F7]'" />
                                </div>
                                <p v-if="isConsumerFound && addresses && !addresses.length" class="m-0 mt-[4px] text-[12px] text-[#999999]">
                                    No address found. Add a new one.
                                </p>
                            </div>

                            <!-- new address form (Google autocomplete) -->
                            <div v-if="isVisible" ref="scrollableDiv" class="p-[12px] rounded-[10px] shadow-[0px_0px_10px_0px_#00000026]">
                                <div ref="addressForm" class="flex flex-col gap-[10px]">
                                    <div>
                                        <label for="address" class="uqcLabel">Address <span class="text-[#EE5851]">*</span></label>
                                        <GoogleAutoComplete v-model="selectedFormattedAddress.address_1" placeholder="Address" :reset="resetAddress"
                                            :input-class="'w-full h-[40px] px-[12px] text-[14px] text-[#333333] outline-none'"
                                            @place-selected="handlePlace" @address-reset="selectedAddress = null" />
                                    </div>
                                    <div>
                                        <label for="address2" class="uqcLabel">Address 2</label>
                                        <inputComponent ref="address2Ref" v-model="selectedFormattedAddress.address_2" name="address2"
                                            placeholder="Enter Address 2" :custom-class="fieldClass" />
                                    </div>
                                    <div>
                                        <label for="state" class="uqcLabel">State <span class="text-[#EE5851]">*</span></label>
                                        <inputComponent ref="stateRef" v-model="selectedFormattedAddress.state_id" name="state" required
                                            placeholder="From address" :disabled="true" :custom-class="fieldClass" />
                                    </div>
                                    <div class="grid grid-cols-2 gap-[8px]">
                                        <div>
                                            <label for="city" class="uqcLabel">City <span class="text-[#EE5851]">*</span></label>
                                            <inputComponent ref="cityRef" v-model="selectedFormattedAddress.city_id" name="city" required
                                                placeholder="From address" :disabled="true" :custom-class="fieldClass" />
                                        </div>
                                        <div>
                                            <label for="zipCode" class="uqcLabel">Zip Code <span class="text-[#EE5851]">*</span></label>
                                            <inputComponent ref="zipCodeRef" v-model="selectedFormattedAddress.postal_code" name="zipCode" required
                                                placeholder="From address" :disabled="true" :custom-class="fieldClass" />
                                        </div>
                                    </div>
                                    <!-- State / City / Zip are filled only from the picked address -->
                                    <p v-if="addressIncomplete" class="m-0 text-[13px] leading-[18px] text-[#EE5851]">
                                        Invalid address: State, City or Zip Code is missing. Please select a complete address.
                                    </p>
                                </div>
                                <div class="flex justify-center gap-[10px] pt-[12px]">
                                    <button type="button" class="uqcBtnCancel" @click="cancelAddressClicked">
                                        Back
                                    </button>
                                    <button type="button" :disabled="isAddAddressValid" class="uqcBtnNext" @click="saveAddress">
                                        Add
                                    </button>
                                </div>
                            </div>

                        <!-- footer: Cancel · Next, pinned to the bottom of the modal -->
                        <div v-show="!isVisible" class="uqcFooter mt-auto flex items-center justify-end gap-[10px]">
                            <button type="button" data-bs-dismiss="modal" class="uqcBtnCancel">
                                Cancel
                            </button>
                            <button type="button" class="uqcBtnNext" :disabled="!validate" @click="submitForm">
                                Next
                            </button>
                        </div>
                    </div>
                    <!-- step 2: quote config → manual-quote/create (shared by every entry point) -->
                    <UQConfigStep
                        v-if="step === 'config'" :consumer="quoteConsumer"
                        @back="preset ? hideModal() : (step = 'customer')" @created="quoteCreated"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import inputComponent from '../partialComponent/inputComponent.vue';
import { mapActions, mapGetters } from "vuex";
import { ref } from 'vue';
import { useToast } from "vue-toastification";
import GoogleAutoComplete from '../partialComponent/GoogleAutoComplete.vue';
import UQConfigStep from '../quote/create/UQConfigStep.vue';
import FxModalHeader from '../nest_components/FxModalHeader.vue';
import customDropdown from '../partialComponent/customDropdown.vue';
import FxSelect from '../partialComponent/FxSelect.vue';
import { uqApi } from '../../services/uqApi';
const toast = useToast();

export default {
    components: {
        inputComponent,
        GoogleAutoComplete,
        UQConfigStep,
        FxModalHeader,
        customDropdown,
        FxSelect
    },
    emits: ["created"],
    data() {
        return {
            email: null,
            phone: null,
            first_name: null,
            last_name: null,
            isConsumerApiCalled: false,
            isConsumerFound: false,
            selectedAddress: null,
            deletedAddress: null,
            addresses: null,
            selectedFormattedAddress: {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            },
            isVisible: false,
            // sources of the consumer (manual-quote/get-consumer-resources); 'consumer' = no source, pick an address
            sources: { appointment: [], replacement_quote: [], service_and_repair: [] },
            sourceType: 'consumer',
            preset: false,
            sourceId: null,
            step: 'customer',
            fieldClass: '!h-[40px] !px-[12px] !rounded-[8px] !border-[#E1E5EF] !text-[14px] !text-[#333333] disabled:!bg-[#F7F8FA] disabled:cursor-not-allowed',
            isOpen: false,
            quoteConsumer: null,
            phoneRef: ref(null),
            firstNameRef: ref(null),
            lastNameRef: ref(null),
            emailRef: ref(null),
        };
    },
    computed: {
        ...mapGetters([
            "consumerDetails",
            "consumerAddresses",
            "deleteAddressResponse",
            "formattedAddress",
            "consumerAddressStoreResponse",
            "addConsumerResponse"
        ]),
        // address dropdown items: saved addresses + "Add new address"
        addressOptions() {
            const list = (this.addresses || []).map(a => ({
                label: a.address_1 + (a.address_2 ? ', ' + a.address_2 : ''),
                value: a.id,
            }));
            return [...list, { label: '+ Add new address', value: '__new' }];
        },
        sourceTypeOptions() {
            const s = this.sources;
            return [
                s.appointment.length && { label: 'Appointment', value: 'appointment' },
                s.replacement_quote.length && { label: 'Replacement Quote', value: 'replacement-quote' },
                s.service_and_repair.length && { label: 'Service & Repair', value: 'service-and-repair' },
                { label: 'Consumer', value: 'consumer' },
            ].filter(Boolean);
        },
        isSourceFlow() {
            return this.isConsumerFound && this.sourceType !== 'consumer';
        },
        sourceTypeLabel() {
            return this.sourceTypeOptions.find(o => o.value === this.sourceType)?.label ?? '';
        },
        sourceIdOptions() {
            const list = { 'appointment': this.sources.appointment, 'replacement-quote': this.sources.replacement_quote, 'service-and-repair': this.sources.service_and_repair }[this.sourceType] || [];
            return list.map(x => ({ label: this.sourceTypeLabel + ' - ' + x.id, value: x.id }));
        },
        // address dropdown: an id, or "__new" opens the new-address form
        selectedAddressId: {
            get() {
                return this.selectedAddress ? this.selectedAddress.id : null;
            },
            set(id) {
                if (id === '__new') {
                    this.selectedAddress = null;
                    this.toggleDiv();
                    return;
                }
                this.selectedAddress = (this.addresses || []).find(a => a.id === id) || null;
            },
        },
        validate() {
            return (
                !this.$refs.phoneRef?.hasError() &&
                !this.$refs.firstNameRef?.hasError() &&
                !this.$refs.lastNameRef?.hasError() &&
                !this.$refs.emailRef?.hasError()
            );
        },
        // a Google address was picked and resolved (address/formatted fills lat, state, city, zip)
        addressPicked() {
            return !!this.selectedFormattedAddress.lat;
        },
        // State / City / Zip come only from the picked address (read-only); a picked address without them is invalid
        addressIncomplete() {
            const a = this.selectedFormattedAddress;
            return this.addressPicked && [a.state_id, a.city_id, a.postal_code].some(v => this.$helper.isEmpty(v));
        },
        // true = "Add" disabled. Address 2 is optional.
        isAddAddressValid() {
            return (
                this.$helper.isEmpty(this.selectedFormattedAddress.address_1) ||
                !this.addressPicked ||
                this.addressIncomplete ||
                this.validateRefFields()
            )
        }
    },
    watch: {
        phone: function (data) {
            const digits = this.phone?.replace(/\D/g, '') ?? "";
            if (digits.length == 10) {
                this.getConsumerDetails({
                    phone: this.phone
                })
            }
            else{
                this.resetDataExceptPhone()
            }
        },

        consumerDetails: function (data) {
            this.resetRefs()
            this.isConsumerApiCalled = true
            this.isConsumerFound = this.consumerDetails.company_consumer_id == 0 ? false : true
            this.selectedAddress = null
            this.deletedAddress = null
            this.addresses = null
            this.selectedFormattedAddress = {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            },
                this.isVisible = false
            this.setConsumer()
            this.loadSources()
        },

        consumerAddresses: function (data) {
            this.addresses = this.consumerAddresses
        },

        deleteAddressResponse: function (data) {
            if ((this.deletedAddress && this.deletedAddress.id) == (this.selectedAddress && this.selectedAddress.id)) {
                this.selectedAddress = null
                this.deletedAddress = null
            }
            this.getConsumerAddresses({
                company_consumer_id: this.consumerDetails.company_consumer_id
            })
        },

        formattedAddress: function (data) {
            console.log("selectedFormattedAddress", this.formattedAddress);

            this.selectedFormattedAddress = this.formattedAddress
        },

        consumerAddressStoreResponse: function (data) {
            if (this.isConsumerFound) {
                toast.success("Address has been added successfully.")
                this.isVisible = false;
                this.getConsumerAddresses({
                    company_consumer_id: this.consumerDetails.company_consumer_id
                })
            } else {
                // two instances can be mounted and both watch this getter: only the open one continues
                if (!this.isOpen) return
                const address = this.consumerAddressStoreResponse[0]
                // consumer + address are stored now: Back from the quote step shows an existing consumer (locked
                // fields, the saved address picked), not "Add address" again, which would store the consumer twice
                this.isConsumerFound = true
                this.isVisible = false
                this.selectedAddress = address
                this.selectedFormattedAddress = { address_1: null, address_2: null, postal_code: null, city_id: null, state_id: null }
                this.getConsumerAddresses({
                    company_consumer_id: this.consumerDetails.company_consumer_id
                })
                this.goToConfig(address)
            }
        },

        addConsumerResponse: function (data) {
            this.consumerDetails.company_consumer_id = this.addConsumerResponse.consumer.id
            this.consumerDetails.consumer_id = this.addConsumerResponse.consumer.consumer_id
            this.saveConsumerAddress()
        },
        isVisible(newVal) {
            this.$nextTick(() => {
                const el = this.$refs.addressForm;
                if (el) {
                    // Clean up old listener if it exists
                    el.removeEventListener('scroll', this.onScrollHandler);
                    if (newVal) {
                        this.onScrollHandler(); // optional initial call
                        el.addEventListener('scroll', this.onScrollHandler);
                    }
                }
            });
        }
    },
    mounted() {
    },
    beforeUnmount() {
        const el = this.$refs.addressForm;
        if (el) {
            el.removeEventListener('scroll', this.onScrollHandler);
        }
    },
    methods: {
        onScrollHandler() {
            const pacContainers = document.querySelectorAll('.pac-container');
            pacContainers.forEach(pac => {
                pac.style.display = 'none';
            });
        },
        ...mapActions([
            "getConsumerDetails",
            "getConsumerAddresses",
            "deleteAddress",
            "getFormattedAddress",
            "addConsumerAddress",
            "storeConsumer"
        ]),
        cancelAddressClicked() {
            this.isVisible = false
            this.selectedFormattedAddress = {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            }
        },
        toggleDiv() {
            this.isVisible = true;
            this.$nextTick(() => {
                const el = this.$refs.scrollableDiv;
                console.log("scrollableDiv", el);
                if (el) el.scrollTop = 0;
            });

        },
        submitForm() {
            if (!this.validateForm()) {
                this.goToConfig(this.selectedAddress)
            }
        },
        // manual-quote/create takes the company consumer id (CompanyConsumer) as consumer_id, like Android
        goToConfig(address) {
            // two instances can be mounted (list page + header) and both watch the same store getters
            if (!this.isOpen) return
            this.quoteConsumer = {
                consumer_id: this.consumerDetails.company_consumer_id,
                user_id: this.consumerDetails.consumer_id,
                // a source (appointment / RQ / S&R) carries its own address, so none is sent
                source_type: this.isSourceFlow ? this.sourceType : 'consumer',
                source_id: this.isSourceFlow ? this.sourceId : 0,
                address_id: this.isSourceFlow ? null : address.id,
                address: this.isSourceFlow ? null : address.address_1,
                phone: this.phone,
                email: (this.email ?? '').trim(),
                first_name: (this.first_name ?? '').trim(),
                last_name: (this.last_name ?? '').trim(),
            }
            this.step = 'config'
            this.$nextTick(() => this.adjustConsumerModalHeight())
        },
        // Android UQConfigFragment opens the quote editor (Vue flow "quote/edit/{id}") after create
        quoteCreated(quote) {
            this.$emit('created', quote)
            this.hideModal()
            this.$router.push({ name: 'QuoteEdit', params: { id: quote.id } })
        },
        saveAddress() {
            if (this.selectedFormattedAddress.lat) {
                if (this.isConsumerFound) {
                    this.saveConsumerAddress()
                } else {
                    if (this.validateRefFields()) {
                        // toast.error("Please fill all required fields.");
                    } else {
                        this.saveConsumer()
                    }
                }
            } else {
                toast.error("Please select address.");
            }
            // this.isVisible = false;
        },
        saveConsumerAddress() {
            this.addConsumerAddress({
                "company_consumer_id": this.consumerDetails.company_consumer_id,
                "address_1": this.selectedFormattedAddress.address_1,
                "street": this.selectedFormattedAddress.street,
                "address_2": this.selectedFormattedAddress.address_2,
                "city_id": this.selectedFormattedAddress.city_id,
                "state_id": this.selectedFormattedAddress.state_id,
                "postal_code": this.selectedFormattedAddress.postal_code,
                "country": this.selectedFormattedAddress.country_name,
                "lat": this.selectedFormattedAddress.lat,
                "long": this.selectedFormattedAddress.long
            })
        },
        saveConsumer() {
            this.storeConsumer({
                "first_name": this.first_name.trim(),
                "last_name": this.last_name.trim(),
                "phone": this.phone,
                "email": this.email.trim()

            })
        },
        deleteAddressClicked(address) {
            this.$confirmDialog.show({
                image: 'delete-confirm-icon.svg',
                title: "Delete Address",
                text: "Are you sure you want to delete this address?",
                onConfirm: () => {
                    this.deletedAddress = address
                    this.deleteAddress({
                        id: address.id
                    })
                },
            });
        },

        validateRefFields() {
            let inputRefer = ["phoneRef", "firstNameRef", "lastNameRef", "emailRef"]
            let hasError = false;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });

            return hasError
        },

        validateForm() {
            let inputRefer = ["phoneRef", "firstNameRef", "lastNameRef", "emailRef"]
            let hasError = false;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });

            if (
                this.$helper.isEmpty(this.phone) ||
                this.$helper.isEmpty(this.first_name) ||
                this.$helper.isEmpty(this.last_name) ||
                !this.isConsumerFound
            ) {
                // toast.error("Please fill all required fields.");
                hasError = true;
            }

            if (this.isSourceFlow) {
                if (!this.sourceId) {
                    toast.error("Please select " + this.sourceTypeLabel + ".")
                    hasError = true;
                }
            } else if (this.selectedAddress === null) {
                toast.error("Please select address.")
                hasError = true;
            }

            return hasError;

        },
        // preset = a ready quoteConsumer (UQ list opened from an S&R job): skip the customer step and open the
        // config step for that job's consumer and source, like Android IndependentQuoteListingFragment → UQConfigFragment
        showModal(preset = null) {
            this.reset()
            if (preset) {
                this.quoteConsumer = preset
                this.preset = true
                this.step = 'config'
            }
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.quotelModal;
            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
                this.adjustConsumerModalHeight();
            });
            modalEl.addEventListener('hidden.bs.modal', () => {
                this.isOpen = false
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
                window.removeEventListener('resize', this.adjustConsumerModalHeight);
                window.removeEventListener('orientationchange', this.adjustConsumerModalHeight);
            });
            window.addEventListener('resize', this.adjustConsumerModalHeight);
            window.addEventListener('orientationchange', this.adjustConsumerModalHeight);
            this.isOpen = true
            this.modal.show();
        },
        hideModal() {
            this.reset()
            if (this.modal) {
                this.modal.hide();
            }
        },
        async loadSources() {
            this.sources = { appointment: [], replacement_quote: [], service_and_repair: [] }
            this.sourceType = 'consumer'
            this.sourceId = null
            if (!this.isConsumerFound) return
            const res = await uqApi.consumerResources(this.phone)
            if (!res.ok) return // no sources: the plain consumer + address flow still works
            this.sources = {
                appointment: res.body?.appointment ?? [],
                replacement_quote: res.body?.replacement_quote ?? [],
                service_and_repair: res.body?.service_and_repair ?? [],
            }
        },
        setConsumer() {
            this.first_name = this.consumerDetails.first_name
            this.last_name = this.consumerDetails.last_name
            this.email = this.consumerDetails.email
            this.addresses = null
            if (this.isConsumerFound) {
                this.getConsumerAddresses({
                    company_consumer_id: this.consumerDetails.company_consumer_id
                })
            }
        },
        resetAddress() {

        },
        handlePlace(place) {
            console.log(place);
            this.getFormattedAddress({
                address: place.formatted_address,
                lat: place.geometry?.location?.lat(),
                lng: place.geometry?.location?.lng(),
            })
        },

        resetRefs() {
            let inputRefer = ["phoneRef", "firstNameRef", "lastNameRef", "emailRef"]
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.resetField === "function") {
                    inputComponent.resetField();
                }
            });
        },
        resetDataExceptPhone(){
            this.resetRefs()
            this.email = null
            this.first_name = null
            this.last_name = null
            this.isConsumerApiCalled = false
            this.isConsumerFound = false
            this.sources = { appointment: [], replacement_quote: [], service_and_repair: [] }
            this.sourceType = 'consumer'
            this.sourceId = null
            this.selectedAddress = null
            this.deletedAddress = null
            this.addresses = null
            this.selectedFormattedAddress = {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            },
                this.isVisible = false
        },
        reset() {
            this.resetRefs()
            this.phone = null
            this.email = null
            this.first_name = null
            this.last_name = null
            this.isConsumerApiCalled = false
            this.isConsumerFound = false
            this.sources = { appointment: [], replacement_quote: [], service_and_repair: [] }
            this.sourceType = 'consumer'
            this.sourceId = null
            this.selectedAddress = null
            this.deletedAddress = null
            this.addresses = null
            this.selectedFormattedAddress = {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            },
                this.isVisible = false
            this.step = 'customer'
            this.quoteConsumer = null
            this.preset = false
        },
        adjustConsumerModalHeight() {
            const contents = this.$refs.quotelModal?.querySelectorAll('.responsiveOreitationConsumerHeightAdjust') ?? [];
            contents.forEach(modalContent => {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 400) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 575) {
                    maxHeight = vh * 0.8 - 40;
                } else if (vw < 750) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.9 - 40;
                } else if (vw < 850) {
                    maxHeight = vh * 0.9 - 40;
                } else if (vw < 950) {
                    maxHeight = vh * 0.5 - 30;
                } else if (vw < 1024) {
                    maxHeight = vh * 0.8 - 30;
                } else if (vw < 1200) {
                    maxHeight = vh * 0.8 - 30;
                } else {
                    maxHeight = vh * 0.8 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            });
        },
    },
};
</script>